module.exports = __webpack_public_path__ + "static/media/photo-1484557052118-f32bd25b45b5.e57e98a0.jpg";